// Read-only snapshot mode (REACT_APP_SNAPSHOT=true): requests are answered from bundled static JSON; nothing hits a network API.
export const SNAPSHOT = process.env.REACT_APP_SNAPSHOT === "true";
export const SNAPSHOT_MSG = "Review copy — not connected. Submissions and sign-in are disabled in this preview.";

let dataPromise;
// Loaded as a script (data.js) because some shared hosts block *.json files.
const load = () => (dataPromise ||= window.__CIARB_SNAPSHOT__ ? Promise.resolve(window.__CIARB_SNAPSHOT__) : new Promise((resolve, reject) => {
  const s = document.createElement("script");
  s.src = `${process.env.PUBLIC_URL || ""}/snapshot/data.js?v=${process.env.REACT_APP_SNAPSHOT_VERSION || "0"}`;
  s.onload = () => resolve(window.__CIARB_SNAPSHOT__);
  s.onerror = () => reject(new Error("Snapshot data unavailable"));
  document.head.appendChild(s);
}));

const reject = (config, status = 503) => Promise.reject(Object.assign(new Error(SNAPSHOT_MSG), {
  config, response: { status, data: { detail: SNAPSHOT_MSG }, headers: {}, config },
}));

const ROUTES = [
  [/^\/public\/bootstrap$/, (d) => d.bootstrap],
  [/^\/public\/pages\/([\w-]+)$/, (d, m) => d.pages[m[1]]],
  [/^\/public\/registration-categories$/, (d) => d.categories],
  [/^\/public\/sponsorship-packages$/, (d) => d.packages],
  [/^\/public\/sponsors$/, (d) => d.sponsors],
  [/^\/public\/speakers$/, (d) => d.speakers],
  [/^\/public\/news$/, (d) => d.news],
  [/^\/public\/news\/([\w-]+)$/, (d, m) => d.news.find((n) => n.slug === m[1])],
  [/^\/virtual\/status$/, (d) => d.virtual_status],
];

export async function snapshotAdapter(config) {
  if ((config.method || "get").toLowerCase() !== "get") return reject(config);
  const data = await load();
  const path = (config.url || "").split("?")[0];
  for (const [re, pick] of ROUTES) {
    const m = path.match(re);
    if (m) {
      const body = pick(data, m);
      if (body === undefined) return reject(config, 404);
      return { data: body, status: 200, statusText: "OK", headers: {}, config, request: {} };
    }
  }
  return reject(config);
}

export const SnapshotNotice = ({ className = "" }) => (SNAPSHOT ? (
  <p role="status" className={`rounded border-2 border-dashed border-gold bg-[#FFFBF0] p-4 font-semibold text-navy ${className}`} data-testid="snapshot-notice">{SNAPSHOT_MSG}</p>
) : null);
